export type SpaceStatus = 'walkable' | 'prototype' | 'hub'
export type SpaceBadgeKind = 'hall' | 'living' | 'spaces' | 'vision'

export interface SpaceDefinition {
  id: string
  /** Route segment under /galleries/:galleryId/ */
  path: string
  title: string
  blurb: string
  badge: string
  badgeKind: SpaceBadgeKind
  status: SpaceStatus
  statusLabel: string
  layers: string
  thumbUrl: string
}

/** Catalog of real Studio space prototypes — not placeholder marketing tiles. */
export const SPACE_CATALOG: SpaceDefinition[] = [
  {
    id: 'present-hall',
    path: 'present-realistic',
    title: 'Present Hall',
    blurb: 'Cinematic walk-in gallery — plaza, glass doors, mirrored floor, hung prints.',
    badge: '◇ HALL',
    badgeKind: 'hall',
    status: 'walkable',
    statusLabel: 'WALKABLE',
    layers: 'Present · prints · SSAO',
    thumbUrl: '/marketing/landing-v2/a07-city.jpg',
  },
  {
    id: 'mountain-lot',
    path: 'mountain-lot',
    title: 'Mountain Lot',
    blurb: 'Glass cabin on a ridge — living-space template from the Shop vision.',
    badge: '◈ LIVING',
    badgeKind: 'living',
    status: 'prototype',
    statusLabel: 'PROTOTYPE',
    layers: 'Shop · terrain · HDRI',
    thumbUrl: '/marketing/landing-v2/a03-mountains.jpg',
  },
  {
    id: 'spaces-studio',
    path: 'spaces-studio',
    title: 'Furniture Studio',
    blurb: 'Bedroom / loft / living presets — place furniture against your hung photos.',
    badge: '◈ SPACES',
    badgeKind: 'spaces',
    status: 'prototype',
    statusLabel: 'PROTOTYPE',
    layers: 'Furniture · Photos · presets',
    thumbUrl: '/marketing/landing-v2/a08-coffee.jpg',
  },
  {
    id: 'virtual-spaces',
    path: 'virtual-spaces',
    title: 'Spaces Vision',
    blurb: 'Hub for Furniture · Photos · Notes · Shop — the Virtual → Egowall bridge.',
    badge: 'VISION',
    badgeKind: 'vision',
    status: 'hub',
    statusLabel: 'HUB',
    layers: 'Furniture · Photos · Notes · Shop',
    thumbUrl: '/marketing/landing-v2/a01-wedding.jpg',
  },
]
